const initialized = new WeakMap<NonNullable<Window["fbq"]>, Map<string, string>>();

export function initializeMetaPixel(pixelId: string, page: string) {
  if (!/^\d{5,}$/.test(pixelId)) return;
  if (!window.fbq) {
    const fbq: NonNullable<Window["fbq"]> = function (...args: unknown[]) {
      if (fbq.callMethod) fbq.callMethod.apply(fbq, args);
      else (fbq.queue ??= []).push(args);
    };
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    fbq.push = fbq;
    window.fbq = fbq;
    window._fbq = fbq;
  }
  const fbq = window.fbq;
  let pixels = initialized.get(fbq);
  if (!pixels) { pixels = new Map(); initialized.set(fbq, pixels); }
  if (!pixels.has(pixelId)) {
    // This form has explicit conversion tracking; do not infer events from its fields/buttons.
    fbq("set", "autoConfig", false, pixelId);
    fbq("init", pixelId);
    pixels.set(pixelId, "");
  }
  if (pixels.get(pixelId) !== page) {
    fbq("trackSingle", pixelId, "PageView");
    pixels.set(pixelId, page);
  }
}
